import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Button,
} from "reactstrap"
import { Link, useLocation } from "react-router-dom"
import Select from "react-select"
import withRouter from "components/Common/withRouter"
import TableContainer from "components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import Breadcrumbs from "components/Common/Breadcrumb"
import Spinners from "components/Common/Spinner"
import { useNavigate } from "react-router-dom"
import toast from "react-hot-toast"
import {
  addNewAdmin,
  getAdminView,
  getSideBarNav,
  updateAdmin,
} from "helpers/fakebackend_helper"
import axios from "axios"

const CreateAdmin = () => {
  const [staicNav, setStaicNav] = useState([])
  const [dynaNav, setDynaNav] = useState([])
  const [Id, setId] = useState()

  //   console.log("staicNav", staicNav)

  const router = useNavigate()
  const [isLoading, setisLoading] = useState(false)
  const [isPageLoading, setisPageLoading] = useState(false)

  const { state } = useLocation()

  const [userList, setUserList] = useState([])
  const [userLists, setUserLists] = useState([])

  const userType1 = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "14", value: "14" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "11", value: "11" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "15", value: "15" },
    { label: "24", value: "24" },
    { label: "30", value: "30" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "31", value: "31" },
    { label: "32", value: "32" },
    { label: "33", value: "33" },
    { label: "34", value: "34" },
    { label: "35", value: "35" },
    { label: "37", value: "37" },
    { label: "38", value: "38" },
    { label: "39", value: "39" },
    { label: "13", value: "13" },
    { label: "40", value: "40" },
    { label: "41", value: "41" },
    { label: "42", value: "42" },
    { label: "43", value: "43" },
    { label: "44", value: "44" },
    { label: "50", value: "50" },
    { label: "51", value: "51" },
    { label: "52", value: "52" },
    { label: "0", value: "0" },
    { label: "53", value: "53" },
    { label: "54", value: "54" },
    { label: "56", value: "56" },
    { label: "58", value: "58" },
    { label: ",1597", value: ",1597" },
    { label: "55", value: "55" },
    { label: "59", value: "59" },
    { label: "61", value: "61" },
    { label: "62", value: "62" },
    { label: "63", value: "63" },
    { label: "65", value: "65" },
    { label: "66", value: "66" },
    { label: "36", value: "36" },
    { label: "67", value: "67" },
    { label: "68", value: "68" },
    { label: "64", value: "64" },
    { label: "69", value: "69" },
    { label: "70", value: "70" },
    { label: "71", value: "71" },
    { label: "72", value: "72" },
    { label: "73", value: "73" },
    { label: "74", value: "74" },
    { label: "75", value: "75" },
    { label: "76", value: "76" },
    { label: "78", value: "78" },
    { label: "80", value: "80" },
    { label: "79", value: "79" },
  ]

  const userType2 = [
    { label: "0", value: "0" },
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" },
    { label: "32", value: "32" },
    { label: "33", value: "33" },
    { label: "34", value: "34" },
    { label: "35", value: "35" },
    { label: "36", value: "36" },
    { label: "37", value: "37" },
    { label: "38", value: "38" },
    { label: "39", value: "39" },
    { label: "40", value: "40" },
    { label: "41", value: "41" },
    { label: "42", value: "42" },
    { label: "43", value: "43" },
    { label: "44", value: "44" },
    { label: "45", value: "45" },
    { label: "51", value: "51" },
    { label: "71", value: "71" },
    { label: "91", value: "91" },
    { label: "92", value: "92" },
    { label: "93", value: "93" },
    { label: "121", value: "121" },
    { label: "122", value: "122" },
    { label: "123", value: "123" },
    { label: "124", value: "124" },
    { label: "125", value: "125" },
    { label: "126", value: "126" },
  ]

  const [sideNav, setSideNav] = useState([])

  const fetchSideNav = () => {
    getSideBarNav()
      .then(res => {
        let temp = []
        res?.navigation_templates?.map((item, ind) => {
          temp.push({
            ...item,
            is_approver: false,
          })
        })
        setSideNav(temp)
      })
      .catch(err => console.log("err", err))
  }

  const getUserList = async () => {
    try {
      const body = {}
      const response = await axios.post(
        "https://tnega.tnschools.gov.in/tnega/api/UserList",
        body,
        { headers: { Authorization: "4acdca2cc493c1ec28e1f68e0d37c49a" } }
      )
      //   console.log("response", response)
      if (response?.data?.dataStatus) {
        let temp = []
        response?.data?.result?.map((item, ind) => {
          temp.push({
            label: item?.Name,
            value: item?.Name,
          })
        })
        setUserList(temp)
        setUserLists(response?.data?.result)
      }
    } catch (error) {
      console.log("error", error)
    }
  }

  useEffect(() => {
    fetchSideNav()
    getUserList()
  }, [])

  const handleGetAdmin = id => {
    setisPageLoading(true)
    getAdminView(id || Id)
      .then(res => {
        adminFormik.setFieldValue("name", res?.name)
        adminFormik.setFieldValue("user_type1", res?.user_type1)
        adminFormik.setFieldValue("user_type2", res?.user_type2)
        // setDynaNav(res?.admin_permissions?.map(r =>  r?.navigation_id) || []);
        let temp = []
        res?.admin_permissions?.map((item, ind) => {
          temp.push({
            ...item,
            id: item?.navigation_id,
            is_approver: item?.is_approver,
          })
        })
        setDynaNav(temp || [])
        setStaicNav(res?.static_permission || [])
        setisPageLoading(false)
      })
      .catch(err => {
        console.log("err", err)
        setisPageLoading(false)
      })
  }

  const handleUpdateAdmin = id => {
    getAdminView(id || Id)
      .then(res => {
        const UserPer = JSON.parse(localStorage.getItem("authUser"))
        if (res.admin_id == UserPer.admin.admin_id) {
          UserPer["admin"] = res
          localStorage.setItem("authUser", JSON.stringify(UserPer))
        }
        router("/admin")
      })
      .catch(err => {
        console.log("err", err)
        router("/admin")
      })
  }

  useEffect(() => {
    if (state?.id) {
      handleGetAdmin(state?.id)
      setId(state?.id)
    }
  }, [state?.id])

  const adminFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      user_type1: "",
      user_type2: "",
      static_permissions: "",
      navigation_ids: "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Enter Name"),
      user_type1: Yup.string(),
      user_type2: Yup.string(),
      static_permissions: Yup.string(),
      navigation_ids: Yup.string(),
    }),
    onSubmit: values => {
      // setisLoading(true)
      let formdata = new FormData()
      formdata.append("name", values.name)
      formdata.append("user_type1", values.user_type1)
      formdata.append("user_type2", values.user_type2)

      staicNav?.map((item, ind) => {
        formdata.append(`static_permission[${ind}]`, item)
      })

      dynaNav?.map((item, ind) => {
        formdata.append(`navigation_ids[${ind}][navigation_id]`, item?.id)
        if (item?.is_approver) {
          formdata.append(
            `navigation_ids[${ind}][is_approver]`,
            item?.is_approver
          )
        } else {
          formdata.append(`navigation_ids[${ind}][is_approver]`, false)
        }
      })

      let body = {
        name: values.name,
        user_type1: values.user_type1,
        user_type2: values.user_type2,
        static_permission: staicNav,
        // navigation_ids: dynaNav,
        navigation_permissions: [],
      }

      dynaNav?.map((item, ind) => {
        body.navigation_permissions.push({
          navigation_id: item?.id,
          is_approver: item?.is_approver ? item?.is_approver : false,
        })
      })

      if (state?.id || Id) {
        formdata.append("admin_id", state?.id || Id)
        body["admin_id"] = state?.id || Id

        updateAdmin(body)
          .then(res => {
            toast.success(res?.message ?? "Updated Successfully")
            const UserPer = JSON.parse(localStorage.getItem("authUser"))
            if (state?.id == UserPer.admin.admin_id) {
              handleUpdateAdmin(state?.id)
            } else {
              if (res?.message == "Admin updated successfully") {
                router("/admin")
              }
            }
          })
          .catch(err => {
            console.log("err", err)
            setisLoading(false)
            toast.error(err?.response?.data?.error ?? "Somthing went Wrong!")
          })
      } else {
        addNewAdmin(body)
          .then(res => {
            if (res?.message?.includes("success")) {
              toast.success(res?.message ?? "Added Successfully")
              router("/admin")
            }
          })
          .catch(err => {
            console.log("err", err)
            setisLoading(false)
            toast.error(err?.response?.data?.error ?? "Somthing went Wrong!")
          })
      }
    },
  })

  const handleOnChange = item => {
    let finder = userLists?.find(i => i?.Name == item?.value)
    adminFormik.setFieldValue("name", item?.value)
    adminFormik.setFieldValue("user_type1", finder?.UserType)
    adminFormik.setFieldValue("user_type2", finder?.UserType1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Admin"
            breadcrumbItem={state?.id ? "UPDATE ADMIN" : "CREATE ADMIN"}
          />

          <Row>
            {isPageLoading ? (
              <Spinners setLoading={setisPageLoading} />
            ) : (
              <Col lg="12">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-3">
                      {state?.id ? "Update Admin" : "Create Admin"}
                    </h4>
                    <form onSubmit={adminFormik.handleSubmit}>
                      <Row>
                        <Col md="4">
                          <div className="mb-3">
                            <Label className="form-label">
                              Name<span className="text-danger">*</span>
                            </Label>
                            <Select
                              placeholder="Select Name"
                              options={userList}
                              getOptionLabel={e => e?.label}
                              getOptionValue={e => e?.value}
                              value={userList?.find(
                                e =>
                                  e?.value ==
                                  adminFormik.getFieldProps("name").value
                              )}
                              onChange={e => {
                                handleOnChange(e)
                              }}
                              invalid={
                                adminFormik.touched.name &&
                                adminFormik.errors.name
                                  ? true
                                  : false
                              }
                              onBlur={adminFormik.handleBlur}
                              className="select2-selection"
                            />
                            {/* <Input
                              name="name"
                              placeholder="Enter name"
                              type="text"
                              onChange={adminFormik.handleChange}
                              onBlur={adminFormik.handleBlur}
                              value={adminFormik.values.name || ""}
                              invalid={
                                adminFormik.touched.name &&
                                adminFormik.errors.name
                                  ? true
                                  : false
                              }
                            /> */}

                            {adminFormik.touched.name &&
                            adminFormik.errors.name ? (
                              <FormFeedback type="invalid">
                                {adminFormik.errors.name}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>

                        <Col md="4">
                          <div className="mb-3">
                            <Label>
                              {/* Select  */}
                              User Type 1<span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="name"
                              placeholder="User Type 1"
                              type="text"
                              value={
                                adminFormik.getFieldProps("user_type1").value ||
                                ""
                              }
                              disabled
                            />
                            {/* <Select
                                placeholder="Select user Type 1"
                                options={userType1}
                                getOptionLabel={e => e?.label}
                                getOptionValue={e => e?.value}
                                value={userType1?.find(
                                e =>
                                    e?.value ==
                                    adminFormik.getFieldProps("user_type1").value
                                )}
                                onChange={e => {
                                adminFormik.setFieldValue("user_type1", e?.value)
                                }}
                                className="select2-selection"
                            /> */}
                            {adminFormik.touched.user_type1 &&
                            adminFormik.errors.user_type1 ? (
                              <p className="mb-0 text-danger mt-1">
                                {adminFormik.errors.user_type1}
                              </p>
                            ) : null}
                          </div>
                        </Col>

                        <Col md="4">
                          <div className="mb-3">
                            <Label>
                              {/* Select  */}
                              User Type 2<span className="text-danger">*</span>
                            </Label>
                            {/* <Select
                                placeholder="Select user Type 2"
                                options={userType2}
                                getOptionLabel={e => e?.label}
                                getOptionValue={e => e?.value}
                                value={userType2?.find(
                                e =>
                                    e?.value ==
                                    adminFormik.getFieldProps("user_type2").value
                                )}
                                onChange={e => {
                                adminFormik.setFieldValue("user_type2", e?.value
                                )
                                }}
                                className="select2-selection"
                            /> */}

                            <Input
                              name="name"
                              placeholder="User Type 2"
                              type="text"
                              value={
                                adminFormik.getFieldProps("user_type2").value ||
                                ""
                              }
                              disabled
                            />
                            {adminFormik.touched.user_type2 &&
                            adminFormik.errors.user_type2 ? (
                              <p className="mb-0 text-danger mt-1">
                                {adminFormik.errors.user_type2}
                              </p>
                            ) : null}
                          </div>
                        </Col>

                        <Col md="12">
                          <div className="mb-3">
                            <h4 className="card-title mb-3">
                              {"Static Navigation Permissions"}
                              <span className="text-danger">*</span>
                            </h4>

                            <div className="row">
                              <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="form-check form-check-success mb-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolorA"
                                    checked={staicNav.some(e => e == "admin")}
                                    onClick={() => {
                                      if (staicNav.find(e => e == "admin")) {
                                        setStaicNav(
                                          staicNav.filter(e => e != "admin")
                                        )
                                      } else {
                                        setStaicNav(p => [...p, "admin"])
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="customCheckcolorA"
                                  >
                                    ADMIN
                                  </label>
                                </div>
                              </div>

                              <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="form-check form-check-success mb-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolorB"
                                    // value={'scert_masters'}
                                    checked={staicNav.some(
                                      e => e == "scert_masters"
                                    )}
                                    onClick={() => {
                                      if (
                                        staicNav.some(e => e == "scert_masters")
                                      ) {
                                        setStaicNav(
                                          staicNav.filter(
                                            e => e != "scert_masters"
                                          )
                                        )
                                      } else {
                                        setStaicNav(p => [
                                          ...p,
                                          "scert_masters",
                                        ])
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="customCheckcolorB"
                                  >
                                    SCERT MASTERS
                                  </label>
                                </div>
                              </div>

                              <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="form-check form-check-success mb-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolorC"
                                    // value={'scert_books'}
                                    checked={staicNav.some(
                                      e => e == "scert_books"
                                    )}
                                    onClick={() => {
                                      if (
                                        staicNav.find(e => e == "scert_books")
                                      ) {
                                        setStaicNav(
                                          staicNav.filter(
                                            e => e != "scert_books"
                                          )
                                        )
                                      } else {
                                        setStaicNav(p => [...p, "scert_books"])
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="customCheckcolorC"
                                  >
                                    SCERT BOOK
                                  </label>
                                </div>
                              </div>

                              <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="form-check form-check-success mb-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolorD"
                                    checked={staicNav.some(e => e == "config")}
                                    onClick={() => {
                                      if (staicNav.find(e => e == "config")) {
                                        setStaicNav(
                                          staicNav.filter(e => e != "config")
                                        )
                                      } else {
                                        setStaicNav(p => [...p, "config"])
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="customCheckcolorD"
                                  >
                                    CONFIGURATION
                                  </label>
                                </div>
                              </div>

                              <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="form-check form-check-success mb-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolorE"
                                    checked={staicNav.some(
                                      e => e == "navigations"
                                    )}
                                    onClick={() => {
                                      if (
                                        staicNav.find(e => e == "navigations")
                                      ) {
                                        setStaicNav(
                                          staicNav.filter(
                                            e => e != "navigations"
                                          )
                                        )
                                      } else {
                                        setStaicNav(p => [...p, "navigations"])
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="customCheckcolorE"
                                  >
                                    NAVIGATIONS
                                  </label>
                                </div>
                              </div>

                              <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="form-check form-check-success mb-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolorf"
                                    checked={staicNav.some(e => e == "blog")}
                                    onClick={() => {
                                      if (staicNav.find(e => e == "blog")) {
                                        setStaicNav(
                                          staicNav.filter(e => e != "blog")
                                        )
                                      } else {
                                        setStaicNav(p => [...p, "blog"])
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="customCheckcolorf"
                                  >
                                    BLOG
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>

                        <Col md="12">
                          <div className="mb-3">
                            <h4 className="card-title mb-3">
                              {"Dynamic Navigation Permissions"}
                              <span className="text-danger">*</span>
                            </h4>

                            <div className="row">
                              {sideNav?.map((data, i) => (
                                <div className="col-md-4 px-2 col-sm-6" key={i}>
                                  <div className="justify-content-between border align-items-center p-2 rounded d-flex gap-3 mb-2 ">
                                    <div className="form-check form-check-success ">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`dynamicNav${i}`}
                                        //   value={'admin'}
                                        checked={dynaNav?.some(
                                          e => e?.id == data?.id
                                        )}
                                        onClick={() => {
                                          if (
                                            dynaNav.find(e => e?.id == data?.id)
                                          ) {
                                            setDynaNav(
                                              dynaNav.filter(
                                                e => e?.id != data?.id
                                              )
                                            )
                                          } else {
                                            console.log("temp2", data)
                                            setDynaNav(p => [...p, data])
                                          }
                                        }}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`dynamicNav${i}`}
                                      >
                                        {data?.eng_name}
                                      </label>
                                    </div>

                                    <div className="form-check form-check-success ">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`dynamicNavap${i}`}
                                        //   value={'admin'}
                                        checked={dynaNav?.find(
                                          e =>
                                            e?.id == data?.id &&
                                            e?.is_approver == true
                                        )}
                                        onClick={() => {
                                          if (
                                            dynaNav?.find(
                                              e => e?.id == data?.id
                                            )
                                          ) {
                                            let temp = [...dynaNav]
                                            let tempIndx = dynaNav?.findIndex(
                                              i => i?.id == data?.id
                                            )
                                            if (
                                              temp[tempIndx].is_approver == true
                                            ) {
                                              temp[tempIndx] = {
                                                ...temp[tempIndx],
                                                is_approver: false,
                                              }
                                            } else {
                                              temp[tempIndx] = {
                                                ...temp[tempIndx],
                                                is_approver: true,
                                              }
                                            }
                                            console.log("temp1", temp)

                                            setDynaNav(temp)
                                          }
                                        }}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`dynamicNavap${i}`}
                                      >
                                        is Approver
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Col>

                        <Col lg={12}>
                          <div className="text-end mb-4">
                            <Button
                              disabled={isLoading}
                              type="submit"
                              color="primary"
                            >
                              {isLoading ? (
                                <>
                                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                  Loading
                                </>
                              ) : state?.id ? (
                                "Update Admin"
                              ) : (
                                "Create Admin"
                              )}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(CreateAdmin)
